/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/RepoPolicies" />
import React = require("react");
import { IPolicy } from "Repos/Views/Settings/Repositories-Policies/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Repositories-Policies/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { IPoliciesViewService } from "../Services/PoliciesViewService";
import { PolicyToggle } from "./PolicyToggle";

interface IRepoPoliciesProps {
    goToProject: () => void;
}

export class RepoPolicies extends VssComponent<IRepoPoliciesProps> {
    public render = (): JSX.Element => {
        const policyService = this.context.pageContext.getService<IPoliciesViewService>("PoliciesViewService");
        return (
            <Observer ready={policyService.isReady()} toggles={policyService.getTogglePolicies()}>
                {({ ready, toggles }: { ready: boolean; toggles: IPolicy[] }) => {
                    return (
                        <Card className="flex-grow policies" titleProps={{ text: Resources.PoliciesTitle }} contentProps={{ contentPadding: false }}>
                            {ready ? (
                                <div className="flex-column flex-grow">
                                    {toggles.map(policy => {
                                        return <PolicyToggle key={policy.type} policy={policy} goToProject={this.props.goToProject} />;
                                    })}
                                </div>
                            ) : (
                                <div className="flex-grow justify-center flex-column padding-16">
                                    <Spinner size={SpinnerSize.large} />
                                </div>
                            )}
                        </Card>
                    );
                }}
            </Observer>
        );
    };
}
